import React, { useEffect, useState} from "react";
import { Button, Modal  } from "react-bootstrap";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import countries from '../../../example_data/dropdowns/clientModal/countries';
import provinces from '../../../example_data/dropdowns/clientModal/provinces';
import {canadaRegions} from '../../../example_data/dropdowns/clientModal/canadaRegions';
import {usaRegions} from '../../../example_data/dropdowns/clientModal/usaRegions';
import states from '../../../example_data/dropdowns/clientModal/states';
import gas_types from '../../../example_data/dropdowns/clientModal/gasTypes';

const GHGModal = props => {
    const floatRegex = /^(-?\d*\.?\d*)?$/;
    const canadaWater = [
        "Toronto Water",
        "Peel Region",
        "York Region",
        "Durham Region",
        "Halton Region",
        "Hamilton Water",
        "Ottawa Water Services",
        "Kitchener-Waterloo-Cambridge (Region of Waterloo)",
        "London Water",
        "Windsor Utilities Commission",
        "Niagara Region",
        "City of Guelph Water Services",
        "City of Barrie Water Operations",
        "City of Kingston Utilities",
        "Montreal (Service de l'eau)",
        "Laval Water Services",
        "Quebec City (Québec Eau Potable)",
        "Winnipeg Water and Waste",
        "Regina Waterworks",
        "Calgary Water Services",
        "Edmonton (EPCOR Water)",
        "Metro Vancouver (Greater Vancouver Water District)",
        "Victoria (Capital Regional District - CRD Integrated Water Services)"
      ]

    const canadaElectricty = [
        "Alberta",
        "British Columbia",
        "Manitoba",
        "New Brunswick",
        "Newfoundland and Labrador",
        "Nova Scotia",
        "Ontario",
        "Prince Edward Island",
        "Quebec",
        "Saskatchewan",
        "Northwest Territories",
        "Nunavut",
        "Yukon"
      ]

    const canadaGas = [
        "Enbridge Gas (Ontario)",
        "Énergir (Quebec)",
        "FortisBC (British Columbia)",
        "ATCO Gas (Alberta)",
        "SaskEnergy (Saskatchewan)",
        "Heritage Gas (Nova Scotia)",
        "Irving Energy (Atlantic Canada)"
      ]
     const usaWater = [
        "New York City Department of Environmental Protection (NYC DEP)",
        "Los Angeles Department of Water and Power (LADWP)",
        "Chicago Department of Water Management",
        "Philadelphia Water Department",
        "Houston Water",
        "San Francisco Public Utilities Commission (SFPUC)",
        "Washington Suburban Sanitary Commission (WSSC Water)",
        "Metropolitan Water District of Southern California (MWD)",
        "Boston Water and Sewer Commission",
        "Atlanta Department of Watershed Management",
        "Miami-Dade Water and Sewer Department",
        "Dallas Water Utilities",
        "Phoenix Water Services",
        "Denver Water",
        "Portland Water Bureau (Oregon)",
        "Seattle Public Utilities",
        "San Diego Public Utilities Department",
        "Detroit Water and Sewerage Department (DWSD)",
        "Cleveland Water",
        "Milwaukee Water Works"
      ]

    const usaElectricity = [
        "Alaska Grid (AKGD)",
         "Alaska Miscellaneous (AKMS)",
         "Arizona/New Mexico (AZNM)",
         "California (CAMX)",
         "Texas (ERCOT) (ERCT)",
         "Florida (FRCC)",
         "Hawaii Miscellaneous (HIMS)",
         "Hawaii Oahu (HIOA)",
         "Upper Midwest East (MROE)",
         "Upper Midwest West (MROW)",
         "New England (NEWE)",
         "Northwest (NWPP)",
         "New York City/Westchester (NYCW)",
         "Upstate New York (NYUP)",
         "Mid-Atlantic East (RFCE)",
         "Mid-Atlantic Central (RFCM)",
         "Mid-Atlantic West (RFCW)",
         "Southeast Central (SRMV)",
         "Southeast Mississippi Valley (SRMW)",
         "Southeast South Atlantic (SRSO)",
         "Southeast Tennessee Valley (SRTV)",
         "South Carolina (SRVC)",
         "Missouri (SPNO)",
         "Oklahoma (SPSO)",
         "Southwest Power Pool North (SPNO)",
         "Southwest Power Pool South (SPSO)"
       ]

    const usaGas = [
        "SoCalGas (California)",
        "Pacific Gas & Electric (PG&E)",
        "Con Edison (New York)",
        "National Grid (Northeast U.S.)",
        "Nicor Gas (Illinois)",
        "Peoples Gas (Florida & Illinois)",
        "CenterPoint Energy (Texas & Midwest)",
        "Dominion Energy (Virginia, Utah, Ohio)",
        "Xcel Energy (Colorado, Minnesota, etc.)",
        "DTE Energy (Michigan)",
        "Atlanta Gas Light (Georgia)",
        "NW Natural (Oregon & SW Washington)"
      ]
    
    const [regionForm, setRegionForm] = useState({
        utility: 'water',
        utilityError: '',
        gasType: '',
        gasError: '',
        region: '',
        regionError: '',
        country: 'Canada',
        countryError: ''
    });

    var years = new Array(20);
    let nextYear = new Date().getFullYear() + 1;
    
    let index = 0;
    while(index < 20){
        years[index++] = nextYear--;    
    }

    const [factorForm, setFactorForm] = useState({
        water_kg_co2_m3: '',
        waterError: '',
        elec_kg_co2_kwh: '',
        elecError: '',
        gas_kg_co2_btu: '',
        gasError: '',
        year: new Date().getFullYear()
    });

    const validateForm = () => {
        let isValid = true;

        if(props.modalState === 'region'){
            let tempForm = {...regionForm};

            if(tempForm.utilityType === ''){
                isValid = false;
                tempForm.utilityError = 'Required';
            }else{
                tempForm.utilityError = '';
            }

            if(tempForm.region.trim() === ''){
                isValid = false;
                tempForm.regionError = 'Required';
            }else{
                tempForm.regionError = '';
            }

            if(tempForm.country.trim() === ''){
                isValid = false;
                tempForm.countryError = 'Required';
            }else{
                tempForm.countryError = '';
            }

            setRegionForm(tempForm);
            return isValid;

        }else if(props.modalState === 'factor' || props.modalState === 'edit-factor'){
            let tempForm = {};
            
            if(props.modalState === 'factor'){
                tempForm = {...factorForm};
            }else{
                tempForm = {...props.factorToEdit};
            }
            
            if(props.selectedTab === 'water'){
                if (tempForm.water_kg_co2_m3.toString().trim() === ''){
                tempForm.waterError = 'Required';
                isValid = false;
                }else if(parseFloat(tempForm.water_kg_co2_m3 ) <= 0){
                tempForm.waterError = 'Value must be greater than 0';
                isValid = false;
                }else{
                tempForm.waterError = '';
                }
            }

            if(props.selectedTab === 'electricity'){
                if (tempForm.elec_kg_co2_kwh.toString().trim() === ''){
                    tempForm.elecError = 'Required';
                    isValid = false;
                }else if(parseFloat(tempForm.elec_kg_co2_kwh) <= 0){
                tempForm.elecError = 'Value must be greater than 0';
                isValid = false;
                }else{
                tempForm.elecError = '';
                }
            }

            if(props.selectedTab === 'gas'){
                if (tempForm.gas_kg_co2_btu.toString().trim() === ''){
                    tempForm.gasError = 'Required';
                    isValid = false;
                }else if(parseFloat(tempForm.gas_kg_co2_btu) <= 0 && props.selectedTab === 'gas'){
                    tempForm.gasError = 'Value must be greater than 0';
                    isValid = false;
                }else{
                    tempForm.gasError = '';
                }
            }

            if(props.modalState === 'factor'){
                setFactorForm(tempForm);
            }else{
                props.setFactorToEdit(tempForm);
            }

            return isValid;
        }
    }

    const generateModalTitle = () => {
        if(props.modalState === 'region'){
            return 'Add new region';
        }else if(props.modalState === 'factor'){
            return `Add new ${props.selectedTab} factor`;
        }else if(props.modalState === 'edit-factor'){
            return 'Edit factor'
        }else if(props.modalState === 'delete-factor'){
            return 'Delete factor?'
        }

        return '';
    }

    return (
        <Modal 
            show={props.modalState !== ''} 
            onHide={() => {
                props.setServerError('');
                
                if(props.modalState === 'edit-factor'){
                    props.setFactorToEdit(null);
                }else if(props.modalState === 'delete-factor'){
                    props.setFactorToDelete(null);
                }else{
                    props.setModalState('');
                }
            }} 
            centered 
            className="opp-modal-root"
            backdropClassName="opp-modal-backdrop"
            dialogClassName="opp-modal-cw"
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title>{generateModalTitle()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.serverError !== '' && <p className="text-error" style={{textAlign:'center'}}>{props.serverError}</p>}
                {
                    props.modalState === 'region' &&
                    <>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Utility Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={regionForm.utility}
                                label="Utility Type"
                                onChange={e => {
                                    setRegionForm(prev => ({
                                        ...prev,
                                        ['utility']: e.target.value,
                                        region: ''
                                    }))
                                }}
                                error={regionForm.utilityError !== ''}
                                MenuProps={{ disablePortal: true }}
                            >    
                                <MenuItem value = "water">Water</MenuItem>
                                <MenuItem value = "electricity">Electricity</MenuItem>
                                <MenuItem value = "gas">Gas</MenuItem>
                
                            </Select>
                            <small className="text-error">{regionForm.utilityError}</small>
                        </FormControl>
                        <br/>
                        <br/>
                        {
                            regionForm.utility === 'gas' && 
                            <>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Gas Type</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={regionForm.gasType}
                                        label="Gas Type"
                                        onChange={e => {
                                            setRegionForm(prev => ({
                                                ...prev,
                                                ['gasType']: e.target.value,
                                                region: ''
                                            }))
                                        }}
                                        error={regionForm.gasError !== ''}
                                        MenuProps={{ disablePortal: true }}
                                    >
                                        <MenuItem value = "natural">Natural Gas</MenuItem>
                                        <MenuItem value = "propane">Propane</MenuItem>
                                        <MenuItem value = "diesel">Diesel</MenuItem>
                                        <MenuItem value = "bunker">Bunker</MenuItem>
                                    </Select>

                                    <small className="text-error">{regionForm.utilityError}</small>
                                </FormControl>

                                <br/>
                                <br/>
                            </>    
                        }
                        
                        {
                            (regionForm.country === 'Canada' || regionForm.country === 'USA') ? 
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Region</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={regionForm.region}
                                    label={regionForm.country === 'Canada' ? 'Province' : 'State'}
                                    onChange={e => {
                                        setRegionForm(prev => ({
                                            ...prev,
                                            ['region']: e.target.value
                                        }))
                                    }}
                                    error={regionForm.regionError !== ''}
                                    MenuProps={{ disablePortal: true }}
                                >
                                    {
                                    regionForm.country === 'Canada' ? (
                                        regionForm.utility === 'water' ? (
                                        canadaWater.map((region, i) => (
                                            <MenuItem value={region} key={i}>{region}</MenuItem>
                                        ))
                                        ) : regionForm.utility === 'electricity' ? (
                                        canadaElectricty.map((region, i) => (
                                            <MenuItem value={region} key={i}>{region}</MenuItem>
                                        ))
                                        ) : regionForm.utility === 'gas' ? (
                                        canadaGas.map((region, i) => (
                                            <MenuItem value={region} key={i}>{region}</MenuItem>
                                        ))
                                        ) : null
                                    ) : regionForm.country === 'USA' ? (
                                        regionForm.utility === 'water' ? (
                                        usaWater.map((region, i) => (
                                            <MenuItem value={region} key={i}>{region}</MenuItem>
                                        ))
                                        ) : regionForm.utility === 'electricity' ? (
                                        usaElectricity.map((region, i) => (
                                            <MenuItem value={region} key={i}>{region}</MenuItem>
                                        ))
                                        ) : regionForm.utility === 'gas' ? (
                                        usaGas.map((region, i) => (
                                            <MenuItem value={region} key={i}>{region}</MenuItem>
                                        ))
                                        ) : null
                                    ) : null
                                    }

                                </Select>
                                <small className="text-error">{regionForm.regionError}</small>
                            </FormControl>
                            :
                            <TextField
                                variant="outlined"
                                fullWidth
                                label='Province/state/territory'
                                value={regionForm.region}
                                onChange={e => {
                                    setRegionForm(prev => ({
                                        ...prev,
                                        ['region']: e.target.value
                                    }))
                                }}
                                error={regionForm.regionError !== ''}
                                helperText={regionForm.regionError}
                            />
                        }

                        <br/>
                        <br/>

                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Country</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={regionForm.country}
                                label="Country"
                                onChange={e => {
                                    setRegionForm(prev => ({
                                        ...prev,
                                        ['country']: e.target.value,
                                        region: ''
                                    }))
                                }}
                                error={regionForm.countryError !== ''}
                                MenuProps={{ disablePortal: true }}
                            >
                                {
                                    countries.map((country, i) => (
                                        <MenuItem value={country} key={i}>{country}</MenuItem>
                                    ))
                                }
                            </Select>
                            <small className="text-error">{regionForm.countryError}</small>
                        </FormControl>
                    </>
                }
                {
                    (props.modalState === 'factor' || props.modalState === 'edit-factor')  && 
                    <>
                        { (props.selectedTab === 'water') &&
                        
                        <>
                            <FormControl variant="outlined" fullWidth>
                            <InputLabel id="demo-simple-select-label">Water emissions factor</InputLabel>
                            <OutlinedInput
                                label='Water emissions factor'
                                endAdornment={<InputAdornment position="end">kg CO<sub>2</sub>e/m<sup>3</sup></InputAdornment>}
                                value={props.modalState === 'edit-factor' ? props.factorToEdit?.water_kg_co2_m3 : factorForm.water_kg_co2_m3}
                                onChange={e => {
                                    if(!floatRegex.test(e.target.value)) return;

                                    if(props.modalState === 'edit-factor'){
                                        props.setFactorToEdit(prev => ({
                                            ...prev,
                                            ['water_kg_co2_m3']: e.target.value
                                        }));
                                    }else{
                                        setFactorForm(prev => ({
                                            ...prev,
                                            ['water_kg_co2_m3']: e.target.value
                                        }));
                                    }
                                }}
                                error={props.modalState === 'edit-factor' ? props.factorToEdit?.waterError !== '' : factorForm.waterError !== ''}
                            />
                            <small className="text-error">{props.modalState === 'edit-factor' ? props.factorToEdit?.waterError : factorForm.waterError}</small>
                        </FormControl>

                        <br/>
                        <br/>
                        </>
                        }
                        { (props.selectedTab === 'electricity') &&
                        
                        <>
                            <FormControl variant="outlined" fullWidth>
                            <InputLabel id="demo-simple-select-label">Electricity emissions factor</InputLabel>
                            <OutlinedInput
                                label='Electricity emissions factor'
                                endAdornment={<InputAdornment position="end">kg CO<sub>2</sub>e/kWh</InputAdornment>}
                                value={props.modalState === 'edit-factor' ? props.factorToEdit?.elec_kg_co2_kwh : factorForm.elec_kg_co2_kwh}
                                onChange={e => {
                                    if(!floatRegex.test(e.target.value)) return;

                                    if(props.modalState === 'edit-factor'){
                                        props.setFactorToEdit(prev => ({
                                            ...prev,
                                            ['elec_kg_co2_kwh']: e.target.value
                                        }));
                                    }else{
                                        setFactorForm(prev => ({
                                            ...prev,
                                            ['elec_kg_co2_kwh']: e.target.value
                                        }));
                                    }
                                }}
                                error={props.modalState === 'edit-factor' ? props.factorToEdit?.elecError !== '' : factorForm.elecError !== ''}
                            />
                            <small className="text-error">{props.modalState === 'edit-factor' ? props.factorToEdit?.elecError : factorForm.elecError}</small>
                        </FormControl>

                        <br/>
                        <br/>
                        </>
                        }

                        { (props.selectedTab === 'gas') &&
                        
                        <>
                            <FormControl variant="outlined" fullWidth>
                            <InputLabel id="demo-simple-select-label">Gas emissions factor</InputLabel>
                            <OutlinedInput
                                label='Gas emissions factor'
                                endAdornment={<InputAdornment position="end">kg CO<sub>2</sub>e/BTU</InputAdornment>}
                                value={props.modalState === 'edit-factor' ? props.factorToEdit?.gas_kg_co2_btu : factorForm.gas_kg_co2_btu}
                                onChange={e => {
                                    if(!floatRegex.test(e.target.value)) return;

                                    if(props.modalState === 'edit-factor'){
                                        props.setFactorToEdit(prev => ({
                                            ...prev,
                                            ['gas_kg_co2_btu']: e.target.value
                                        }));
                                    }else{
                                        setFactorForm(prev => ({
                                            ...prev,
                                            ['gas_kg_co2_btu']: e.target.value
                                        }));
                                    }
                                }}
                                error={props.modalState === 'edit-factor' ? props.factorToEdit?.gasError !== '' : factorForm.gasError !== ''}
                            />
                            <small className="text-error">{props.modalState === 'edit-factor' ? props.factorToEdit?.gasError : factorForm.gasError}</small>
                        </FormControl>
                        
                        <br/>
                        <br/>
                        </>
                        }
                        

                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Year</InputLabel>
                            <Select
                                disabled={props.modalState === 'edit-factor'}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={props.factorToEdit?.year}
                                label='Year'
                                onChange={e => {
                                    setFactorForm(prev => ({
                                        ...prev,
                                        ['year']: e.target.value
                                    }))
                                }}
                                MenuProps={{ disablePortal: true }}
                            >
                                {
                                    years.map((year, i) => (
                                        <MenuItem value={year} key={i}>{year}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </>
                }
                {
                    props.modalState === 'delete-factor' &&
                    <p>Are you sure you want to permanently delete the {props.factorToDelete?.year} {props.factorToDelete?.factorIndex}GHG factors for {props.factorToDelete?.territory}?</p>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button
                    style={{backgroundColor:`${props.modalState === 'delete-factor' ? '#DC4C64' : 'rgb(8,114,182)'}`, outline:'none', border:'none'}}
                    onClick={() => {
                        if(props.modalState === 'delete-factor'){
                            props.deleteFactor();
                            return;
                        }
                        
                        if(!validateForm()) return;

                        if(props.modalState === 'region') props.submitForm(regionForm);
                        else if(props.modalState === 'factor') props.submitForm(factorForm);
                        else if(props.modalState === 'edit-factor') props.submitForm(props.factorToEdit);
                    }}
                >
                    {props.modalState === 'delete-factor' ? 'Delete' : 'Submit'}
                </Button>
            </Modal.Footer>
        </Modal>
      );
  }

export default GHGModal;